import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { waLink, telLink } from "@/lib/site-utils";

export const FloatingCTAs = () => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.8, duration: 0.6 }}
    className="fixed bottom-5 right-5 z-50 flex flex-col gap-3"
  >
    <a
      data-testid="float-whatsapp-btn"
      href={waLink("नमस्ते SS Group! मुझे बुकिंग चाहिए।")}
      target="_blank"
      rel="noreferrer"
      className="group grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-black shadow-lg shadow-black/40 hover:scale-110 transition-transform duration-200"
      aria-label="WhatsApp"
    >
      <MessageCircle size={26} fill="currentColor" />
    </a>
    <a
      data-testid="float-call-btn"
      href={telLink()}
      className="group grid place-items-center h-14 w-14 rounded-full bg-jcb text-black shadow-lg shadow-black/40 hover:scale-110 transition-transform duration-200"
      aria-label="Call Now"
    >
      <Phone size={24} strokeWidth={2.5} />
    </a>
  </motion.div>
);
